import React from "react";
import { Link } from "react-router-dom";

export const couponListColumns = ({handleEdit, handleDelete, pageSize}) => [
   {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * pageSize + index + 1,
  },
  {
    label: "Coupon Name",
    render: (row) => row.name,    
  },
  {
    label: "Coupon Type",
    render: (row) => (
        <span> {row.couponType}</span>
    )
  },
  {
    label: "Discount",
    render: (row) => (
      <div>
        {row.couponType === "Discount"
          ? `₹${row.discount}`
          : `${row.discount}%`}
      </div>

    ),
  },
  {
    label: "Start Date",
    render: (row) => (
      
       <span>{row?.startDate
              ? new Date(row.startDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              : "-"}
              </span>
    ),
  },
  {
    label: "End Date",
    render: (row) => (
      <span>{row?.endDate
              ? new Date(row.endDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              : "-"}
              </span>
    ),
  },
  {
    label: "Coupon Details",
    render: (row) => (
      <div>
       {row.couponDetails}
      </div>
    ),
  },
  {
    label: "Status",
    render: (row) => (
      <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link  onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link  onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
];
